import { absoluteImageUrl } from '../utils/environment'
import { GiftBanners } from '../../types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiGiftBanners = (strapiData: any): GiftBanners => {
    const { attributes } = strapiData
    const { paymentSuccessImg, subscriptionStatusFormBanner, subscriptionStatusDetailsBanner } = attributes

    return {
        paymentSuccessImg: absoluteImageUrl(paymentSuccessImg.data.attributes.url),
        subscriptionStatusFormBanner: absoluteImageUrl(subscriptionStatusFormBanner.data.attributes.url),
        subscriptionStatusDetailsBanner: absoluteImageUrl(subscriptionStatusDetailsBanner.data.attributes.url),
    }
}

export { fromStrapiGiftBanners }